import Guid from '@/app/utils/guid';
import { Activity } from '@/stakeholders/entities/activity';
import { Attitude } from '@/stakeholders/entities/attitude';
import Entity from '@/common/models/entity';

export default class Stakeholder extends Entity {

  public name = ''
  public role = ''
  public showRole = false
  public description = ''
  public activity = Activity.Active
  public attitude = Attitude.Neutral
  public keywords: string[] = []
  public region: string = ''
}
